import { RoutePrefix } from '#/routing/classes/RoutePrefix';
import { rootPrefix } from '#/routing/routes';

export const userDashboardPrefix = new RoutePrefix('/dashboard');

export const userDashboardRootRedirectPath = userDashboardPrefix.rootPath();

export const userDashboardSelectOrgPath = rootPrefix.path('select-org');

export const userDashboardSavedItemsPath = userDashboardPrefix.path(
  'saved-items',
  ['tab', 'page'],
);

export const userDashboardViewEmploymentOnboardingPath =
  userDashboardPrefix.path('employment-profile/:slug', ['applied']);

export const userDashboardCreateGroupPath = rootPrefix.path('groups/create', [
  'step',
]);

export const userDashboardListEventsPath = userDashboardPrefix.path('events');

export const userDashboardCreateEventPath = userDashboardPrefix.path(
  'events/create',
  ['step'],
);

export const userDashboardViewEventPath =
  userDashboardPrefix.path('events/:eventId');

export const userDashboardPreviewEventPath = userDashboardPrefix.path(
  'events/:eventId/preview',
);

export const userDashboardEditEventPath = userDashboardPrefix.path(
  'events/:eventId/edit',
);

export const userDashboardProfilePath = userDashboardPrefix.path('profile');

export const userDashboardProfessionalExperiencePath = userDashboardPrefix.path(
  'professional-experience',
);

export const userDashboardNotificationPreferencesPath =
  userDashboardPrefix.path('notification-preferences');

export const userDashboardAccountSettingsPath =
  userDashboardPrefix.path('account-settings');

export const userDashboardPaymentMethodsAddCardPath = userDashboardPrefix.path(
  'payment-methods/add-card',
);

export const userDashboardApplicationHistoryPath = userDashboardPrefix.path(
  'application-history',
  ['page'],
);

export const userDashboardApplicationSummaryPath = userDashboardPrefix.path(
  'application-summary/:applicationId',
);
